import { useCasablancaSpaces } from '../CasablancClient/useCasablancaSpaces';
export function useSpaces(opts, spaceIds, casablancaClient) {
    const casablancaSpaces = useCasablancaSpaces(opts, spaceIds, casablancaClient);
    return { spaces: casablancaSpaces };
}
//# sourceMappingURL=useSpaces.js.map